import styled from 'styled-components'
import { PetTypeEnum } from '@/apis/rest/generated/types'
import FlatIcon from '@/components/common/icons/FlatIcon'
import { TopNavIconButton, TopNavTitle } from '@/components/common/top-nav'
import { TopNav, TopNavLeftArea, TopNavRightArea } from '@/components/common/top-nav/top-nav'
import { CartItemCountCircle } from '@/components/domains/etc'
import { FitpetMallEventEnum } from '@/constants/fitpet-mall-event.enum'
import { GlobalColorEnum } from '@/constants/global-color.enum'
import { IconNameEnum } from '@/constants/icon-name.enum'
import { IconSizeEnum } from '@/constants/icon-size.enum'
import ROUTES from '@/constants/legacy/constRoutes'
import { LocationEnum } from '@/constants/location.enum'
import { PathParamKeyEnum } from '@/constants/path-param-key.enum'
import { ServiceEnum } from '@/constants/service.enum'
import { useTracker } from '@/containers/contexts/EventTrackingProvider'
import { useCustomRouter, usePetType } from '@/containers/hooks'
import appBridgeProvider, { isInAppFlag } from '@/utils/utilBridge'
import type { Bridge } from '@/utils/bridge/bridge'

/**
 * 쿠폰함 페이지 Title TopNav 컴포넌트 UI
 *
 * `/mall/mypage/coupons`
 */
export const MypageCouponsTopNav = () => {
  const router = useCustomRouter()
  const tracker = useTracker()

  const { getPetType } = usePetType()

  const handleClickButtonHome = () => {
    tracker.triggerCustomEvent(FitpetMallEventEnum.ClickGnbHomeIcon, {
      service: ServiceEnum.Mypage,
      location: LocationEnum.Coupon,
    })

    if (isInAppFlag) {
      appBridgeProvider((bridge: Bridge) => bridge.goDeepLink('fitpetmall', '/main'))
      return
    }

    router.push(ROUTES.INDEX)
  }

  const handleClickButtonSearch = () => {
    tracker.triggerCustomEvent(FitpetMallEventEnum.ClickGnbSearchIcon, {
      service: ServiceEnum.Mypage,
      location: LocationEnum.Coupon,
    })
    router.push({
      pathname: ROUTES.SEARCH,
      query: { [PathParamKeyEnum.PetType]: getPetType() || PetTypeEnum.DOG },
    })
  }

  const handleClickButtonCart = () => {
    tracker.triggerCustomEvent(FitpetMallEventEnum.ClickGnbCartIcon, {
      service: ServiceEnum.Mypage,
      location: LocationEnum.Coupon,
    })
    router.push(ROUTES.CART)
  }

  const handleClickBackButton = () => {
    router.back()
  }

  return (
    <TopNav>
      <TopNavLeftArea>
        <TopNavIconButton type={IconNameEnum.IcBack} onClick={handleClickBackButton} />
      </TopNavLeftArea>
      <TopNavTitle>쿠폰함</TopNavTitle>
      <TopNavRightArea>
        <TopNavIconButton type={IconNameEnum.IcHome} onClick={handleClickButtonHome} />
        <TopNavIconButton type={IconNameEnum.IcSearch} onClick={handleClickButtonSearch} />
        <StyledTopNavIconButton asChild onClick={handleClickButtonCart}>
          <CartItemCountCircle />
          <FlatIcon type={IconNameEnum.IcCart} size={IconSizeEnum.Size24} color={GlobalColorEnum.Gray900} />
        </StyledTopNavIconButton>
      </TopNavRightArea>
    </TopNav>
  )
}

const StyledTopNavIconButton = styled(TopNavIconButton)`
  position: relative;
`
